import { datadogLogs, type LogsEvent } from '@datadog/browser-logs';
import type { APP_ENV } from '@main/shared/utils';
import posthog from 'posthog-js';

type BeforeSend = (event: LogsEvent) => boolean | void;

export function initDatadogLogger({
  clientToken,
  site,
  appEnv,
  version,
  isProdBuild,
  service,
  beforeSend,
}: {
  clientToken: string;
  site: string;
  appEnv: APP_ENV;
  version: string;
  isProdBuild: boolean;
  service: 'app' | 'backoffice' | 'vendor-portal' | 'trust-portal';
  beforeSend?: BeforeSend;
}) {
  datadogLogs.logger.setHandler(isProdBuild ? 'http' : 'console');

  datadogLogs.init({
    clientToken,
    site,
    env: appEnv,
    service,
    version,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: (event) => {
      event.view.url = event.view.url.replace(/token=[^&]*/, 'token=REDACTED');

      if (appEnv.includes('prod')) {
        event.view['posthog_session'] = posthog.get_session_replay_url({ withTimestamp: true });
      }

      if (event.http && event.http.status_code === 404) {
        return false;
      }

      if (beforeSend?.(event) === false) {
        return false;
      }

      return true;
    },
  });
}
